import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Profile.css";

export default function Profile() {
  const navigate = useNavigate();

  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);

  const userEmail = localStorage.getItem("email");

  // LOAD PROFILE
  useEffect(() => {
  if (!userEmail) return;

  const token = localStorage.getItem("access-token"); // ✅ correct place

  axios
    .get(`https://rhrmapi.up2dateinc.com/api/auth/profile/${userEmail}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res.data) {
        setProfile({
          _id: res.data._id,
          firstName: res.data.firstName || "",
          lastName: res.data.lastName || "",
          email: res.data.email || userEmail,
          userName: res.data.userName || "",
          password: "",
        });
      }
    })
    .catch((err) => console.log("Load error:", err));
}, [userEmail]);

  // HANDLE INPUT
  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  // SAVE PROFILE
  const saveProfile = async () => {
    try {
      if (!userEmail) {
        alert("User not found ❌");
        return;
      }

      setLoading(true);

      const updatedData = {
        ...profile,
        email: userEmail
      };

     const token = localStorage.getItem("access-token"); // ✅ add this line

    const res = await axios.put(
      `https://rhrmapi.up2dateinc.com/api/auth/${updatedData._id}`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ add this
        },
      }
    );

      if (res.data) {
        alert("✅ Profile updated successfully");
        navigate("/chat");
      } else {
        alert("❌ Update failed");
      }
    } catch (err) {
      console.log(err);
      alert("❌ Server error");
    } finally {
      setLoading(false);
    }
  };

  if (!userEmail) {
    return <h3 style={{ textAlign: "center" }}>Please login first</h3>;
  }

  return (
    <div className="profile-page">

      <div className="profile-card">

        <h2>Edit Profile</h2>

        <div className="profile-form">

          <div className="input-group">
            <label>First Name</label>
            <input
              name="firstName"
              value={profile.firstName}
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label>Last Name</label>
            <input
              name="lastName"
              value={profile.lastName}
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label>User Name</label>
            <input
              name="userName"
              value={profile.userName}
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label>Email</label>
            <input value={profile.email} disabled />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={profile.password}
              onChange={handleChange}
              placeholder="Enter new password"
            />
          </div>

        </div>

        <div className="profile-buttons">
          <button onClick={saveProfile} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>

          <button onClick={() => navigate("/chat")}>
            Cancel
          </button>
        </div>

      </div>
    </div>
  );
}